import gql from 'graphql-tag';
import {client} from "./client";
import {AllLayers} from "../../schema/AllLayersPublic";
import {Query} from "../../types";

export async function requestLayers (): Promise<any> {
    const queryName = 'allLayers';
    try {
        const result: {data: Query} = await client.query({
            query: gql`${AllLayers}`
        });
        return result.data[queryName]!.nodes;
    } catch (e) {
        console.warn(e);
    }
}